import React from "react";

const CommentItemShimmer = () => {
    return (
        <div className="d-flex align-items-start mb-3 mt-3 comment-item">
            {/* Profile picture skeleton */}
            <div className="skeleton skeleton-circle me-2 profile-picture-skeleton" />

            <div className="d-flex flex-column flex-grow-1">
                <div className="d-flex align-items-center gap-2 flex-wrap">
                    {/* Name skeleton */}
                    <div className="skeleton skeleton-text comment-name-skeleton" />
                    {/* Time skeleton */}
                    <div className="skeleton skeleton-text comment-time-skeleton flex-grow-1" />
                </div>
                {/* Comment text skeleton */}
                <div className="skeleton skeleton-text comment-content-skeleton" style={{ marginTop: "8px" }} />
                <div className="skeleton skeleton-text comment-content-skeleton" style={{ marginTop: "8px", width: "80%" }} />
            </div>

            <style jsx>{`
				.skeleton {
					background-color: #e0e0e0;
					position: relative;
					overflow: hidden;
				}
				.skeleton::after {
					content: "";
					position: absolute;
					top: 0;
					left: -100%;
					width: 100%;
					height: 100%;
					background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
					animation: shimmer 1.5s infinite;
				}
				@keyframes shimmer {
					100% {
						transform: translateX(100%);
					}
				}
				.skeleton-circle {
					border-radius: 50%;
					width: 40px;
					height: 40px;
				}
				.skeleton-text {
					border-radius: 4px;
					height: 16px;
					width: 100%;
				}
				.comment-name-skeleton {
					width: 120px;
					height: 16px;
				}
				.comment-time-skeleton {
					width: 80px;
					height: 16px;
				}
				.comment-content-skeleton {
					height: 16px;
				}
			`}</style>
        </div>
    );
};

export default CommentItemShimmer;
